//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import OPZDialog from '@/components/OPZDialog';
import OPZTable from '@/components/OPZTable';
import { getOutDeliverBillDetail } from '@/api/WMS/out/crossDockingList';
export default {
  name: 'Common334',
  components: {
    OPZDialog: OPZDialog,
    OPZTable: OPZTable
  },
  props: {
    rowData: {
      type: [Object, null],
      default: null
    },
    fieldData: {
      type: [Object, null],
      default: null
    }
  },
  data: function data() {
    return {
      dialog: {
        title: '包裹明细',
        width: 800,
        visible: false,
        columns: [{
          prop: 'spu',
          label: '款号'
        }, {
          prop: 'color',
          label: '颜色/尺码',
          type: 'html',
          htmlFormatter: function htmlFormatter(val, _ref) {
            var size = _ref.size;
            return "<p>".concat(val || '--', "/").concat(size || '--', "</p>");
          }
        }, {
          prop: 'pictureUrl',
          label: '图片',
          type: 'image'
        }, {
          prop: 'quantity',
          label: '数量'
        }, {
          prop: 'sku',
          label: 'SKU编码'
        }],
        data: {}
      }
    };
  },
  methods: {
    handleClick: function handleClick() {
      var _this = this;
      getOutDeliverBillDetail("\"".concat(this.rowData.deliverNo, "\"")).then(function (res) {
        if (res.code === 200 && res.data) {
          _this.dialog.data = res.data || {};
          _this.dialog.visible = true;
        } else {
          _this.$message.warning('无数据');
        }
      });
    }
  }
};